import React, {Fragment, useEffect, useRef} from "react";
import { connect } from "react-redux";
import $ from "jquery";

import WithOverlay from "../../../popups/withOverlayHoc";
import LookLockTutorialModal from "./lookLockTutorialModal";
import {setLookLockedTutorial} from "../../../../actions/lookFunctions";

const LookLockTutorial = (props) => {

  const {lookLockedTutorial, setLookLockedTutorial, lookActiveCategory, isMobile} = props;
  const {visible, finished, step, withGrid} = lookLockedTutorial;
  // const [anchorStyles, setAnchorStyles] = useState({});
  const lookTutorialModalRef = useRef();

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setLookLockedTutorial({
          step: 1
        })
      }, 300)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  useEffect(() => {
    if (!lookActiveCategory && visible) {
      setLookLockedTutorial({
        visible: false,
        step: 0,
        // finished: true
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveCategory])

  useEffect(() => {
    if (step !== 1 && step !== 2) {
      return; // when we finish the wizard we set 0, and we don't need to scroll once again
    }
    const firstLockedElem = document.querySelector((step === 1) ? ".lm-feature--unlocked" : ".lm-feature--locked");
    if (!firstLockedElem) {
      console.log("can't find any scroll element to", );
      return;
    }
    const scrollDiv =  firstLockedElem.closest(withGrid ? ".ReactVirtualized__Grid" : ".lm-content");
    if (isMobile || (scrollDiv && (scrollDiv.scrollHeight > scrollDiv.clientHeight))) {
      if (scrollDiv) {
        $(scrollDiv).animate({scrollTop: firstLockedElem.offsetTop - 30}, 800);
      }
      return
    }
    // console.log("firstLockedElem", firstLockedElem);
    const modalEl = document.querySelector(".look-lock__mod");
    if (modalEl) {
      $(modalEl).animate({ top: firstLockedElem.getBoundingClientRect().top - 150 }, 800);
    }

    // const setTop = () => {
    //   if (firstLockedElem && firstLockedElem.getBoundingClientRect) {
    //     // console.log("firstLockedElem.getBoundingClientRect()", firstLockedElem.getBoundingClientRect());
    //     setAnchorStyles({
    //       top: firstLockedElem.getBoundingClientRect().top + 50
    //     });
    //   }
    // }
    // setTop()
    // setTimeout(() => {
    //   setTop()
    // }, 300)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step])

  if (!visible || finished) {
    return null
  }

  return (
    <WithOverlay className={"overlay--look-locked-tutorial overlay--look-locked-tutorial--step-" + step
      + (withGrid ? " overlay--look-locked-tutorial--grid" : "")}>
      {(hideOverlay) => (
        <Fragment>
          <div className={"look-lock__anchor look-lock__anchor--step-" + step} ref={lookTutorialModalRef}/>
          <LookLockTutorialModal withGrid={withGrid} anchorEl={lookTutorialModalRef} hideOverlay={hideOverlay}/>
        </Fragment>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveCategory, lookLockedTutorial} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookActiveCategory,
    lookLockedTutorial,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookLockedTutorial
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(LookLockTutorial)
)
